import { useEffect, useRef, useState } from 'react';

export function useMonitorJobListWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    let ro = null;

    if (el) {
      ro = new ResizeObserver(([entry]) => {
        setWidth(entry.contentRect.width);
      });
      ro.observe(el);
    }

    return () => ro && ro.disconnect();
  }, []);

  return { ref, width };
}
